import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { THEMES } from 'src/global/constants';
import { storeSettings } from '@cigam/template/dist/utils/settings';

const SettingsContext = createContext();

const defaultSettings = {
  direction: 'ltr',
  responsiveFontSizes: true,
  theme: THEMES.CIGAM,
  apiUrl: null,
  cdnUrl: null,
  cdnKey: 1,
  themes: null,
  portalBpmUrl: null,
  activePortals: null,
  defaultLogin: 'cigam',
};

export function SettingsProvider({ settings, children }) {
  const [currentSettings, setCurrentSettings] = useState(
    settings || defaultSettings
  );

  const handleSaveSettings = (updatedSettings = {}) => {
    setCurrentSettings(updatedSettings);
    storeSettings(updatedSettings);
  };

  useEffect(() => {
    document.dir = currentSettings.direction;
  }, [currentSettings]);

  return (
    <SettingsContext.Provider
      value={{
        settings: currentSettings,
        saveSettings: handleSaveSettings,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

SettingsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  settings: PropTypes.object,
};

export const SettingsConsumer = SettingsContext.Consumer;

export default SettingsContext;
